import { Shul } from '../types';
import { LatLng, distanceMeters, hasCoords } from './geo';

/** Meters from `origin` to the shul, or undefined when the shul has no map location. */
export function shulDistance(shul: Shul, origin: LatLng): number | undefined {
  return hasCoords(shul) ? distanceMeters(origin, shul) : undefined;
}

/**
 * Search by name or address. Sorted by name in the current language, or,
 * after the user tapped Near me (`origin`), nearest first (shuls without a
 * map location last).
 */
export function filterAndSortShuls(
  shuls: Shul[],
  query: string,
  isHebrew: boolean,
  origin?: LatLng | null
): Shul[] {
  const q = query.trim().toLowerCase();
  const filtered = q
    ? shuls.filter(
        (s) =>
          s.nameEn.toLowerCase().includes(q) ||
          s.nameHe.includes(query.trim()) ||
          (s.address ? s.address.toLowerCase().includes(q) : false)
      )
    : shuls;

  const byName = (a: Shul, b: Shul) =>
    (isHebrew ? a.nameHe : a.nameEn).localeCompare(isHebrew ? b.nameHe : b.nameEn, isHebrew ? 'he' : 'en');

  if (!origin) return [...filtered].sort(byName);

  const distances = new Map(filtered.map((s) => [s.id, shulDistance(s, origin) ?? Infinity]));
  return [...filtered].sort((a, b) => distances.get(a.id)! - distances.get(b.id)! || byName(a, b));
}
